function f(e, n) {
  e.indexOf(n) === -1 && e.push(n);
}
function d(e, n) {
  const i = e.indexOf(n);
  i > -1 && e.splice(i, 1);
}
export {
  f as addUniqueItem,
  d as removeItem
};
